import React from "react";
import '../../i18n';
import SignIn from '../SignIn/SignIn';
import Welcome from '../Welcome/Welcome';

class LoggedIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null
    }
  }

  loggedIn = (userDetails) => {
    this.setState({
      user: userDetails
    })
  }
  
  signOut = () => {
    this.setState({user: null})
  }
  
  render() {
    return (
      <div>
        { 
          (this.state.user) ? 
            <Welcome 
             user={this.state.user} 
             onSignOut={ this.signOut } 
            />
          :
            <SignIn 
             onloggedIn={ this.loggedIn } 
            />
        }
      </div>
    )
    
  }
  
}

export default LoggedIn;